module.exports = __webpack_public_path__ + "static/media/menuList-bg-shape.907e07de.svg";